import { render, staticRenderFns } from "./Upcoming.vue?vue&type=template&id=cb590340"
import script from "./Upcoming.vue?vue&type=script&setup=true&lang=ts"
export * from "./Upcoming.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./Upcoming.vue?vue&type=style&index=0&id=cb590340&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports